export default "__VITE_ASSET__DKKS3itr__"